import { action } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { CoreUserService } from 'common/data';

class CoreUserStore extends BaseStore {
	constructor(rootStore) {
		super(new CoreUserService(rootStore.app.baasic.apiClient));
	}

	@action async findCoreUser(filter) {
		const response = await this.service.find(filter);
		response.data.searchQuery = filter.search;
		return (this.response = response.data);
	}

	@action async findByUserName(username, options) {
		const response = await this.service.findByUserName(username, options);
		return (this.response = response.data);
	}
}

export default CoreUserStore;



// WEBPACK FOOTER //
// ./src/core/stores/CoreUserStore.js